'use client';

import { Bot } from 'lucide-react';
import { useAiChatStore } from '@/stores/ai-chat-store';

export function AiFloatingButton() {
  const setOpen = useAiChatStore((s) => s.setOpen);

  return (
    <button
      onClick={() => setOpen(true)}
      className="fixed right-4 bottom-6 z-40 h-12 w-12 rounded-full bg-gradient-to-br from-primary to-primary-dark text-primary-foreground shadow-card shadow-primary/30 flex items-center justify-center hover:shadow-elev hover:scale-105 transition-all duration-200"
    >
      <Bot className="h-5 w-5" />
    </button>
  );
}
